import * as React from 'react';

export default function ChevronUpIcon({ width, height, color, className, style }) {
  const _width = width ?? 29;
  const _height = height ?? _width;
  const _color = color ?? 'white';

  return (
    <svg
      width={_width}
      height={_height}
      viewBox={`0 0 ${_width} ${_height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M8.06295 18.2325C7.83271 18.409 7.5 18.2448 7.5 17.9547V14.4034C7.5 14.2946 7.55066 14.1919 7.63705 14.1257L14.5 8.86407L21.363 14.1257C21.4493 14.1919 21.5 14.2946 21.5 14.4034V17.9547C21.5 18.2448 21.1673 18.409 20.937 18.2325L14.5 13.2974L8.06295 18.2325Z"
        fill={_color}
      />
    </svg>
  );
}
